"use strict";

exports.__esModule = true;
exports.modelPaginatedResult = modelPaginatedResult;
var pagination = {
  modelPaginatedResult: modelPaginatedResult
};

exports.default = pagination;

/**
 * @param {Object} response - response from the server with paginated results
 * @param {function} model - the model function to run results through
 * @returns {Object} containing the paginated result with mutated "results"
 */

function modelPaginatedResult(response, model) {
  response.results = response.results.map(model);
  return response;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/services/pagination.js
// module id = 1080
// module chunks = 0